import { useCheckGetAllAccountsRequest } from 'components/use-get-all-accounts-request/use-get-all-accounts-request';
import MyInvoices from 'containers/my-invoices/my-invoices';
import React from 'react';

/**
 * List of accounts
 */
const InvoicesListPage = () => {
  useCheckGetAllAccountsRequest();

  return <div className={'invoices-list'}>
    <MyInvoices />
  </div>;
};

export default InvoicesListPage;
